import { useTranslation } from 'react-i18next';

type PortalContextOption = {
  patientId: string;
  relationship: string;
  firstName: string;
  lastName: string;
};

type TopbarProps = {
  topSearch: string;
  onTopSearchChange: (value: string) => void;
  activeContext: PortalContextOption | null;
  contexts: PortalContextOption[];
  onContextChange: (patientId: string) => void;
  refreshing: boolean;
  onRefresh: () => void;
  patientDisplayName: string;
  avatarInitials: string;
};

export default function Topbar({
  topSearch,
  onTopSearchChange,
  activeContext,
  contexts,
  onContextChange,
  refreshing,
  onRefresh,
  patientDisplayName,
  avatarInitials,
}: TopbarProps) {
  const { t } = useTranslation();
  return (
    <header className="portal-topbar">
      <label className="portal-search" htmlFor="patient-portal-search">
        <span className="portal-search-icon" />
        <input
          id="patient-portal-search"
          value={topSearch}
          onChange={(event) => onTopSearchChange(event.target.value)}
          placeholder={t('layout.searchPlaceholder')}
        />
      </label>

      <div className="portal-topbar-actions">
        {contexts.length > 1 ? (
          <select
            className="portal-context-select"
            value={activeContext?.patientId || ''}
            onChange={(event) => onContextChange(event.target.value)}
          >
            {contexts.map((context) => (
              <option key={context.patientId} value={context.patientId}>
                {context.relationship === 'SELF' ? t('common.me') : context.relationship} · {context.firstName} {context.lastName}
              </option>
            ))}
          </select>
        ) : null}
        <button
          type="button"
          className="portal-action-button"
          onClick={onRefresh}
          disabled={refreshing}
        >
          {refreshing ? t('common.refreshing') : t('common.refresh')}
        </button>
        <div className="portal-profile-chip">
          <div className="portal-profile-avatar">{avatarInitials}</div>
          <div className="portal-profile-copy">
            <p>{patientDisplayName}</p>
            <span>{t('common.patient')}</span>
          </div>
        </div>
      </div>
    </header>
  );
}
